import { Component, OnInit, Input, SimpleChanges, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-tree-content',
  templateUrl: './tree-content.component.html',
  styleUrls: ['./tree-content.component.css'],
})
export class TreeContentComponent implements OnInit {
  constructor() {}

  @Input() Text: string = '';
  @Input() status: string = '';
  @Input() ID: string = '';
  ngOnInit() {}
  checkIfStudyUnit(Text: string): boolean {
    if (Text && Text.includes('Study Unit :')) {
      return true;
    } else {
      return false;
    }
  }
}
